export const getCompanyVerification = (company) => {
    const value = company?.isCompanyVerified ?? company?.companyVerified;
    if (value === true || value === 'true' || value === 1) return true;
    if (value === false || value === 'false' || value === 0) return false;
    return null;
};

// Keep existing consumers compatible with the API's isCompanyVerified field.
export const normalizeCompanyVerification = (company) => {
    if (!company || typeof company !== 'object' || Array.isArray(company)) return company;
    return { ...company, companyVerified: getCompanyVerification(company) };
};
